import { Component, OnInit } from '@angular/core';
import { AstrolyticsService } from "../../_services/astrolytics.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-seller-ranking-page',
  templateUrl: './seller-ranking-page.component.html',
  styleUrls: ['./seller-ranking-page.component.css']
})
export class SellerRankingPageComponent implements OnInit {

  protected rankingData;
  protected loading;

  private sellerRankingDataSubscription: Subscription;

  constructor(private astrolityicsService: AstrolyticsService) { }

  ngOnInit() {
    this.loading = true;
    this.rankingData = undefined;

    this.sellerRankingDataSubscription = this.astrolityicsService.sellerRankingObservable.subscribe((response) => {
      console.log(response);
      if (response.ranking) {
        this.loading = false; 
        this.rankingData = response.ranking
      } else {
        this.rankingData = []
      }

    })

    this.astrolityicsService.getSellerRankingData();

  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.sellerRankingDataSubscription.unsubscribe();
  }

  getRankEmoji(rank) {

    let emojis = {
      "1": "🥇",
      "2": "🥈",
      "3": "🥉"
    }

    let emoji = emojis[rank]

    return emoji ? emoji : `#${rank}`
  }

  getCardWidth(rank) {

    switch (rank) {
      case 1:
        return "80rem"
      case 2:
        return "70rem"
      case 3:
        return "60rem"
      default:
        return "50rem"
    }
  }

}
